



























































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

export default Vue.extend<any, any, any, any>({
  name: 'ApiLogsGrid',
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  created() {
    this.expandedItems = [];
  },
  data() {
    return {
      expandedItems: [],
      headers: [
        {
          text: 'TYPE',
          sortable: false,
          value: 'type',
          width: '100px',
          class: 'primary-column',
        },
        {
          text: 'ACTION',
          sortable: false,
          value: 'action',
          width: '180px',
          class: 'primary-column',
        },
        {
          text: 'MESSAGE',
          sortable: false,
          value: 'message',
          width: '40%',
          class: 'primary-column message-column',
        },
        {
          text: 'TIMESTAMP (EST)',
          sortable: false,
          value: 'createdDateTime',
          width: '150px',
        },
        {
          text: 'TRACE #',
          sortable: false,
          value: 'traceId',
          width: '300px',
        },
      ],
    };
  },
  methods: {
    getTraceIdColor(traceId) {
      if (!traceId) return '#0b436a';

      let hash = 0;
      for (let i = 0; i < traceId.length; i++) {
        hash = traceId.charCodeAt(i) + ((hash << 5) - hash);
      }

      const colors = [
        '#1976D2',
        '#388E3C',
        '#E64A19',
        '#7B1FA2',
        '#C2185B',
        '#00796B',
        '#FBC02D',
        '#5D4037',
        '#455A64',
        '#0097A7',
        '#D32F2F',
        '#303F9F',
        '#689F38',
        '#F57C00',
        '#512DA8',
        '#00796B',
        '#FFA000',
        '#AFB42B',
        '#8D6E63',
        '#00ACC1',
      ];

      const colorIndex = Math.abs(hash) % colors.length;
      return colors[colorIndex];
    },

    toggleExpand(item) {
      const index = this.expandedItems.indexOf(item);

      if (index === -1) {
        // if not expanded, only expand the clicked item
        this.expandedItems = [...this.expandedItems, item];
      } else {
        // if already expanded, only collapse the clicked item
        this.expandedItems = this.expandedItems.filter(
          (expandedItem) => expandedItem !== item
        );
      }
    },
    viewDetails(item) {
      this.$emit('viewDetails', item);
    },
    isJsonString(str) {
      if (!str) return false;

      const tryParse = (jsonCandidate) => {
        try {
          const cleaned = jsonCandidate.trim().replace(/\\"/g, '"');
          if (
            (cleaned.startsWith('{') && cleaned.endsWith('}')) ||
            (cleaned.startsWith('[') && cleaned.endsWith(']'))
          ) {
            JSON.parse(cleaned);
            return true;
          }
        } catch {
          // ignore error
        }
        return false;
      };

      if (tryParse(str)) return true;

      const separator = ' | ';
      if (str.includes(separator)) {
        const [, jsonPart] = str.split(separator);
        if (jsonPart && tryParse(jsonPart)) return true;
      }

      return false;
    },
    copyToClipboard(text) {
      if (!text) return;
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      this.$toast.show('Copied to clipboard!');
    },
    formatJsonHtml(message) {
      if (!message) return '';

      const extractAndFormat = (str) => {
        try {
          const cleaned = str.trim().replace(/\\"/g, '"');
          const parsed = JSON.parse(cleaned);
          return this.syntaxHighlightJson(parsed);
        } catch {
          const match = str.match(/(\{.*\}|\[.*\])/s);
          if (match) {
            try {
              const cleaned = match[0].replace(/\\"/g, '"');
              const parsed = JSON.parse(cleaned);
              return this.syntaxHighlightJson(parsed);
            } catch {
              return null;
            }
          }
        }
        return null;
      };

      if (message.includes(' | ')) {
        const [prefix, jsonPart] = message.split(' | ', 2);
        const formatted = extractAndFormat(jsonPart);
        return formatted ? `${prefix} | ${formatted}` : message;
      }

      const formatted = extractAndFormat(message);
      return formatted || message;
    },
    formatJson(json) {
      return JSON.stringify(json, null, 2);
    },
    syntaxHighlightJson(json) {
      // convert the JSON object to a formatted string
      const jsonStr = JSON.stringify(json, null, 2);

      // apply syntax highlighting with HTML
      return jsonStr
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(
          /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
          (match) => {
            let cls = 'json-number';
            if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                cls = 'json-key';
                // remove the colon from the key
                match = match.replace(/:$/, '');
              } else {
                cls = 'json-string';
              }
            } else if (/true|false/.test(match)) {
              cls = 'json-boolean';
            } else if (/null/.test(match)) {
              cls = 'json-null';
            }
            return `<span class="${cls}">${match}</span>`;
          }
        );
    },
    getStatusClass(type) {
      return {
        'success-status': type === 'Info',
        'error-status': type === 'Error',
        'warning-status': type === 'Warning',
      };
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return 'N/A';

      // format timestamp as "YYYY-MM-DD HH:MM:SS"
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return 'N/A';

      // Convert from CST to EST (CST is UTC-6, EST is UTC-5, so add 1 hour)
      const estDate = new Date(date.getTime() + 1 * 60 * 60 * 1000);

      return estDate.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZone: 'America/New_York',
      });
    },
    isRequestMessage(message) {
      return message && message.includes('Request |');
    },
    isResponseMessage(message) {
      return message && message.includes('Response |');
    },
    formatMessage(message) {
      if (!message) return '';

      // replace escaped quotes with regular quotes for better readability
      return message.replace(/\\"/g, '"');
    },
  },
  computed: {
    ...mapGetters('apiLogs', ['page']),
    pageData() {
      return this.page || [];
    },
  },
  watch: {
    pageData: {
      handler() {
        // reset expandedItems when data changes
        this.expandedItems = [];
      },
      immediate: true,
    },
  },
});
